<match-wrapper
    label="{{ label }}"
    objectType="{{ objectType }}"
    fieldName="{{ fieldName }}"
    (onRemoveMatch)="removeMatch()"
    [showRemoveIcon]="!disabled"
    provideParentForm
>
    <div>
        <label
            aviLabelWithTooltip
            objectType="{{ PathMatch }}"
            fieldName="match_criteria"
            required
        >
            {{ globalL10nKeys.criteriaLabel | vtranslate }}
        </label>
        <avi-enum-dropdown
            enum="StringOperation"
            id="{{ 'path-match-with-objects_match_criteria__' + fieldName + '_' + index }}"
            name="{{ 'path-match-with-objects_match_criteria__' + fieldName + '_' + index }}"
            [(ngModel)]="config.match_criteria"
            placeholder="{{ globalL10nKeys.selectCriteriaPlaceholder | vtranslate }}"
            [disabled]="disabled"
            required
        ></avi-enum-dropdown>
    </div>
    <avi-checkbox-container-group>
        <avi-checkbox
            name="{{ 'path-match-with-objects_match_case_' + fieldName + '_' + index }}"
            [disabled]="disabled"
            [(ngModel)]="config.match_case"
            customTrueValue="SENSITIVE"
            customFalseValue="INSENSITIVE"
            objectType="{{ PathMatch }}"
            fieldName="match_case"
        >
            {{ l10nKeys.enableMatchCaseLabel | vtranslate }}
        </avi-checkbox>
        <avi-checkbox
            name="{{ 'path-match-with-objects_match-decoded-string_' + fieldName + '_' + index }}"
            [disabled]="disabled"
            [(ngModel)]="config.match_decoded_string"
            objectType="{{ PathMatch }}"
            fieldName="match_decoded_string"
        >
            {{ l10nKeys.matchDecodedStringLabel | vtranslate }}
        </avi-checkbox>
    </avi-checkbox-container-group>
    <string-group-or-custom-value
        id="{{ 'path-match-with-objects_match-str_' + fieldName + '_' + index }}"
        [(stringGroupRefs)]="config.string_group_refs"
        [(customValues)]="config.match_str"
        [noMarginTop]="true"
        [areStringGroupOrCustomFieldsRequired]="true"
        label="{{ globalL10nKeys.stringLabel | vtranslate }}"
        [disabled]="disabled"
    ></string-group-or-custom-value>
</match-wrapper>
